import { GAME_ID, REDUX_ACTIONS, GHOST_CELL_STATES } from 'a/wordSlide/data/constants';

const initialState = [];

const sliderReducer = (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_QUESTION_DATA:
      return payload.tiles.map(() => ({
        ghostCellState: GHOST_CELL_STATES.NO,
      }));

    case REDUX_ACTIONS.SET_SLIDER_GHOST_CELL_STATE:
      return state.map((sliderState, i) => ({
        ghostCellState: i === payload.sliderIndex ? payload.ghostCellState : sliderState.ghostCellState,
      }));

    default:
      return state;
  }
};

export default sliderReducer;
